import React from "react";
import { useTranslation } from "react-i18next";
import { AddExistingDestinationIcon, CreateNewDestinationIcon } from "../common/ProjectIcons";

type AddDestinationChoiceViewProps = {
    onAddExisting: () => void;
    onCreateNew?: () => void;
}

const AddDestinationChoiceView = ({ onAddExisting, onCreateNew }: AddDestinationChoiceViewProps) => {
    const { t } = useTranslation();
    return (
        <div className="mt-6 flex flex-col items-center">
            <p className="text-off-black text-xl mb-8 transition-colors duration-300">
                {t("How would you like to add a destination to this connection?")}
            </p>
            <div className="flex flex-row gap-6 w-full max-w-2xl">
                <button
                    type="button"
                    className="flex-1 flex flex-col items-center justify-center gap-3 rounded-lg p-8 border-2 border-dark-green bg-light-green hover:bg-light-green-hover hover:shadow-md cursor-pointer transition-all duration-200"
                    onClick={onAddExisting}
                    data-testid="AddDestinationChoiceView-add-existing-button"
                >
                    <AddExistingDestinationIcon />
                    <span className="text-off-black font-semibold text-lg transition-colors duration-300">{t("Add Existing Destination")}</span>
                    <span className="text-secondary-gray text-sm text-center transition-colors duration-300">{t("Connect a destination that is already set up.")}</span>
                </button>
                {onCreateNew && (
                    <button
                        type="button"
                        className="flex-1 flex flex-col items-center justify-center gap-3 rounded-lg p-8 border-2 border-gray-lines bg-white hover:border-dark-green hover:shadow-md cursor-pointer transition-all duration-200"
                        onClick={onCreateNew}
                    >
                        <CreateNewDestinationIcon />
                        <span className="text-off-black font-semibold text-lg transition-colors duration-300">{t("Create New Destination")}</span>
                        <span className="text-secondary-gray text-sm text-center transition-colors duration-300">{t("Set up a brand new destination and connect it.")}</span>
                    </button>
                )}
            </div>
        </div>
    );
};

export default AddDestinationChoiceView;
